export enum SortTypeEnum {
  Ascending = "asc",
  Descending = "desc",
}
export enum TypeRequestEnum {
  All = "all",
  MyRequest = "my_request",
}
export interface QueryParam {
  page: number;
  typeRequest: TypeRequestEnum;
  search_value: string;
  status?: RequestFeatureStatus;
  sortBypeVote?: SortTypeEnum;
  sortBypeCreated?: SortTypeEnum;
}
export enum RequestFeatureStatus {
  Rejected = 'rejected',
  Pending = 'pending',
  Approved = 'approved',
  Planned = 'planned',
  Developing = 'developing',
  Completed = 'completed',
}
export interface RequestFeatureData {
  id: number;
  title: string;
  description: string;
  status?: RequestFeatureStatus;
  number_of_votes: number;
  created_at: string;
  updated_at: string;
  shop_id: number;
  voted: boolean;
}

export interface RequestFeatureMeta {
  count: number;
  items: number;
  page: number;
  pages: number;
  ransack: A;
}